import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { FaTrash } from "react-icons/fa6";
import SplitPane from "react-split-pane";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyDatasetsServices } from "../../../../APIServices/studyDatasetsServices";

const EmailList = ({ transferId }) => {
  const [emails, setEmails] = useState([]);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const handleEmailChange = (index, value) => {
    const updatedEmails = [...emails];
    updatedEmails[index] = value;
    setEmails(updatedEmails);
  };

  const handleAddEmailField = () => {
    setEmails([...emails, ""]);
  };

  const handleRemoveEmail = (index) => {
    setEmails(emails.filter((_, i) => i !== index));
  };

  const updateStudyDatasetTransfer = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update eMail lists!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        const validEmails = emails
          .map((e) => e.trim())
          .filter((e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e));
        const userData = {
          transferId,
          emails: validEmails,
          studyId,
          mode: StudyMode,
          type: "emails",
        };
        let data = await studyDatasetsServices.updateStudyDatasetTransfer(
          userData
        );
        if (data?.statusCode === 200) {
          getSingleDataTransferedInfo();
        }
        setButtonLoader(false);
      }
    });
  };

  const getSingleDataTransferedInfo = async () => {
    setLoader(true);
    const data = await studyDatasetsServices.getSingleDataTransferedInfo(
      studyId,
      transferId,
      "emails"
    );
    setEmails(data?.data?.emails || []);
    setLoader(false);
  };

  useEffect(() => {
    if (transferId) {
      getSingleDataTransferedInfo();
    }
  }, [transferId]);

  return (
    <SplitPane
      split="vertical"
      minSize="100%"
      style={{ height: "-webkit-fill-available" }}
    >
      {loader ? (
        <PageLoader/>
      ) : emails?.length > 0 ? (
        <>
          <div className="p-2 hstack justify-content-between position-sticky top-0 bg-white">
            <button
              className={`updateProfile`}
              style={{ fontSize: 12 }}
              onClick={handleAddEmailField}
            >
              Add More Emails
            </button>
            <button
              style={{ fontSize: 12 }}
              onClick={updateStudyDatasetTransfer}
              className={`updateProfile`}
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm"/> Updating...
                </div>
              ) : (
                "Update"
              )}
            </button>
          </div>
          <div className="p-2 pt-0">
            {emails.map((email, index) => (
              <div key={index} className="d-flex align-items-center mb-2">
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => handleEmailChange(index, e.target.value)}
                  className="me-2"
                />
                <FaTrash
                  className="text-danger CP"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleRemoveEmail(index)}
                />
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="hstack justify-content-center h-100">
          <NoDataFoundTable MSG={"Emials not found!"} />
        </div>
      )}
    </SplitPane>
  );
};

export default EmailList;
